/* eslint-disable no-else-return */
/* eslint-disable no-unsafe-optional-chaining */

const ROW_HEIGHT = 34;
const NAME_COLUMN_MIN_WIDTH = 150;
const PROPERTY_COLUMN_MIN_WIDTH = 130;

const calculatePropertyColumnWidth = (name: string) =>
  Math.max(PROPERTY_COLUMN_MIN_WIDTH, (name?.length || 0) * 8 + 32);

const headerRow = (tableItemsProperty_: any, tableProperty_: any) => {
  const nameOptions = tableItemsProperty_
    .filter((item: any) => item?.name !== null)
    .reduce((accumulator: any, item: any) => {
      if (!accumulator.includes(item?.name)) {
        accumulator.push(item?.name);
      }
      return accumulator;
    }, []);

  return {
    rowId: 'header',
    height: 38,
    cells: [
      {
        type: 'filter',
        options: nameOptions,
        id: 'name',
        text: 'Name',
        hasDelete: false,
        hasEdit: false,
        nonEditable: true,
        className: 'header-cell header-first',
        isModernFilter: true,
      },
      ...(tableProperty_?.length
        ? tableProperty_?.map((data: any) => {
            const options = tableItemsProperty_
              .filter((item: any) => item[data?.id] !== null)
              .reduce((accumulator: any, item: any) => {
                if (!accumulator.includes(item[data?.id])) {
                  accumulator.push(item[data?.id]);
                }
                return accumulator;
              }, []);
            const row = {
              type: 'filter',
              options,
              id: data?.id,
              hasDelete: true,
              hasEdit: true,
              colType: 'header',
              text: data?.name,
              className: `header-cell `,
              isModernFilter: true,
            };
            return row;
          })
        : []),
    ],
  };
};

const getRows = (tableItemsProperty_: any, tableProperty_: any) => {
  return [
    headerRow(tableItemsProperty_, tableProperty_),
    ...(tableItemsProperty_?.length
      ? tableItemsProperty_?.map((item: any, index: any) => {
          return {
            rowId: index,
            height: ROW_HEIGHT,
            itemId: item?.id,
            itemName: item?.name,
            reorderable: true,
            cells: [
              {
                type: 'text',
                placeholder: 'Enter value',
                text: `${item?.name}` ?? '',
                property: 'name',
                rows: tableItemsProperty_?.length,
                className: 'name',
                hasFormulaError: false,
                hideTooltip: true,
                index,
              },
              ...(tableProperty_?.length
                ? tableProperty_?.map((data: any) => {
                    if (
                      data?.name.trim().toLowerCase() === 'start' ||
                      data?.name.trim().toLowerCase() === 'end' ||
                      data?.name.trim().toLowerCase() === 'start date' ||
                      data?.name.trim().toLowerCase() === 'end date'
                    ) {
                      const row = {
                        type: 'date',
                        text: item[`${data?.id}`] || '',
                        date: new Date(),
                        nonEditable: !item?.id,
                        isModernDate: true,
                      };
                      return row;
                    } else if (data?.items) {
                      const row = {
                        type: 'dropdown',
                        nonEditable: !item?.id,
                        selectOption: true,
                        selectedValue: item[`${data?.id}`],
                        values: [
                          ...(data?.items?.length
                            ? data?.items?.map((value: any) => ({
                                label: value?.name,
                                value: value?.name,
                              }))
                            : []),
                        ],
                        index,
                        operation: '',
                        data,
                        isModernDropdown: true,
                      };
                      return row;
                    } else {
                      const row = {
                        type: 'text',
                        rows: tableItemsProperty_?.length,
                        text: item[`${data?.id}`] ?? '',
                        index,
                        data,
                        hasFormulaError: false,
                        nonEditable: !item?.id,
                        hideTooltip: true,
                        // className: `${index_ === tableProperty_?.length - 1 ? ' last-index ' : ''}`,
                      };
                      return row;
                    }
                  })
                : []),
            ],
          };
        })
      : []),
  ];
};

const getColumns = (tableProperty_: any, tableReference: any) => {
  const propertyColumns = (tableProperty_?.length ? tableProperty_ : []).map((data: any) => ({
    columnId: `${data?.id}`,
    name: data?.name,
    width: calculatePropertyColumnWidth(data?.name),
    resizable: true,
    reorderable: true,
  }));

  const fixedWidth =
    NAME_COLUMN_MIN_WIDTH + propertyColumns.reduce((sum: number, col: any) => sum + col.width, 0);
  const extraSpace = tableReference > fixedWidth ? tableReference - fixedWidth : 0;

  return [
    {
      columnId: 'name',
      width: NAME_COLUMN_MIN_WIDTH + extraSpace,
      resizable: true,
    },
    ...propertyColumns,
  ];
};

const reorderArray = <T extends {}>(array: T[], idxs: number[], to: number) => {
  const movedElements = array.filter((_, index) => idxs.includes(index));
  const targetIndex =
    Math.min(...idxs) < to ? (to += 1) : (to -= idxs.filter((index) => index < to).length);
  const leftSide = array.filter((_, index) => index < targetIndex && !idxs.includes(index));
  const rightSide = array.filter((_, index) => index >= targetIndex && !idxs.includes(index));
  const reorderedArray = [...leftSide, ...movedElements, ...rightSide];
  const idsOnlyArray = reorderedArray.map((item: any) => item.id);
  return idsOnlyArray;
};

export { headerRow, getRows, getColumns, reorderArray };
